<hr-slider
  *ngIf="slides"
  [slides]="slides"
  [slideIndex]="slideIndex"
></hr-slider>
<!-- (formEmitter)="getFormData($event)"
  (finishStepsEmitter)="saveForm($event)"
  [finishLocked]="savingTrilha"
  [canFinish]="canEdit" -->
